export interface GenerateForms149Payload {
  reasonsForFiling: Record<string, any>
  personalData: Record<string, any>
  reasonForCommunication: Record<string, any>
}

function cloneObject(value: unknown): Record<string, any> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {}
  }

  return { ...(value as Record<string, any>) }
}

function normalizeDate(value: unknown): string | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined
  }

  const text = String(value).trim()
  return text.length > 0 ? text : undefined
}

export function buildGenerateForms149Payload(input: any): GenerateForms149Payload {
  const reasonsForFiling = cloneObject(input?.reasonsForFiling)
  if (reasonsForFiling.dependantInfo) {
    delete reasonsForFiling.dependantInfo
  }

  if (Array.isArray(reasonsForFiling.services)) {
    reasonsForFiling.services = reasonsForFiling.services.filter((item: any) => !!item && typeof item === 'object' && item.employeeStatus !== false)
  }

  if (Array.isArray(reasonsForFiling.servicesCommunications)) {
    reasonsForFiling.servicesCommunications = reasonsForFiling.servicesCommunications.filter((item: any) => !!item && typeof item === 'object' && item.employeeStatus !== false)
  }

  if (reasonsForFiling.nonComplianceDate) {
    reasonsForFiling.nonComplianceDate = normalizeDate(reasonsForFiling.nonComplianceDate)
  }
  if (reasonsForFiling.endOfDisplacement) {
    reasonsForFiling.endOfDisplacement = normalizeDate(reasonsForFiling.endOfDisplacement)
  }

  const personalData = cloneObject(input?.personalData)
  const reasonForCommunication = cloneObject(input?.reasonForCommunication)
  const hasForm = Object.prototype.hasOwnProperty.call(reasonForCommunication, 'form')

  if (hasForm) {
    const form = cloneObject(reasonForCommunication.form)
    reasonForCommunication.form = form
    const hasEmploymentInfo = !!form.employmentInfo
    const hasTaxpayerAssociated = !!form.taxpayerAssociated

    if (hasEmploymentInfo) {
      const employmentInfo = cloneObject(form.employmentInfo)
      if (employmentInfo.entryDateInSpain) {
        employmentInfo.entryDateInSpain = normalizeDate(employmentInfo.entryDateInSpain)
      }
      if (employmentInfo.startDateActivity) {
        employmentInfo.startDateActivity = normalizeDate(employmentInfo.startDateActivity)
      }
      form.employmentInfo = employmentInfo
      if (!hasTaxpayerAssociated) {
        form.taxpayerAssociated = {}
      }
    }

    if (hasTaxpayerAssociated) {
      const taxpayerAssociated = cloneObject(form.taxpayerAssociated)
      if (taxpayerAssociated.entryDateInSpain) {
        taxpayerAssociated.entryDateInSpain = normalizeDate(taxpayerAssociated.entryDateInSpain)
      }
      if (taxpayerAssociated.birthDate) {
        taxpayerAssociated.birthDate = normalizeDate(taxpayerAssociated.birthDate)
      }
      form.taxpayerAssociated = taxpayerAssociated
      if (!hasEmploymentInfo) {
        form.employmentInfo = {}
      }
    }
  }

  return {
    reasonsForFiling,
    personalData,
    reasonForCommunication,
  }
}
